module.exports = __webpack_public_path__ + "static/scale-model-of-buffalo-double-decker-tours-in-buffalo-new-york-6296be5fa5e83a4f873b0ed180049660.png";